<!-- Компонент диалогового окна изменения информации о телефонах -->
<template>
  <scroll-center-dialog
    v-model="open"
    @close="close"
    @apply="checkForm"
    :title="select ? 'Изменить телефон' : 'Добавить телефон'"
    :scrolled="false"
  >
    <v-card flat class="pt-4">
      <v-autocomplete
        class="py-1"
        :error="hasError('code')"
        :error-messages="getError('code')"
        item-title="text"
        item-value="value"
        :items="accountCountryCode"
        label="Телефонный код страны"
        variant="outlined"
        placeholder="Россия (+7)"
        v-model="form.code"
      ></v-autocomplete>
      <v-text-field
        class="py-1"
        :error="hasError('number')"
        :error-messages="getError('number')"
        label="Номер"
        placeholder="9876543210"
        variant="outlined"
        v-model="form.number"
      ></v-text-field>
      <v-select
        class="py-1"
        :error="hasError('kind')"
        :error-messages="getError('kind')"
        :items="contactType"
        label="Вид"
        item-title="text"
        item-value="value"
        variant="outlined"
        required
        v-model="form.kind"
      ></v-select>
      <v-checkbox
        :error="hasError('is_visible')"
        :error-messages="getError('is_visible')"
        label=" Виден всем пользователям"
        variant="outlined"
        v-model="form.is_visible"
      ></v-checkbox>
    </v-card>
  </scroll-center-dialog>
</template>

<script>
import ScrollCenterDialog from '@/modules/templates/ScrollCenterDialog'
import FormErrorsMixin from '@/mixins/FormErrorsMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ImageCropper',
  props: {
    value: Boolean,
    select: Object,
  },
  mixins: [FormErrorsMixin],
  components: {
    ScrollCenterDialog,
  },
  data () {
    return {
      open: false,
      form: {
        code: null,
        kind: null,
        number: null,
        is_visible: false,
      },
    }
  },
  watch: {
    value: {
      /**
       * Сохраняет значение value в open при его изменении
       */
      immediate: true,
      handler () {
        this.open = this.value
      },
    },
    open: {
      /**
       * Генерирует событие input с текущим значением open при его изменении
       */
      immediate: true,
      handler () {
        this.$emit('input', this.open)
      },
    },
  },
  computed: {
    ...mapGetters({
      contactType: 'choices/contactType',
      accountCountryCode: 'selectors/accountCountryCode',
    }),
  },
  methods: {
    ...mapActions({
      loadContactType: 'choices/loadContactType',
      loadAccountCountryCode: 'selectors/loadAccountCountryCode',
      createUserPhone: 'user/createUserPhone',
      updateUserPhone: 'user/updateUserPhone',
    }),
    /**
     * Загружает телефонные коды стран
     */
    loadChoices () {
      this.loadAccountCountryCode({
        url: undefined,
        finalizer: (val) => {
        },
      })
    },
    /**
     * Загружает виды контактов
     */
    loadSelectors () {
      this.loadContactType({
        url: undefined,
        finalizer: (val) => {
        },
      })
    },
    /**
     * Генерирует событие close для сохранения
     */
    save () {
      this.$emit('close')
    },
    /**
     * Создаёт новый телефон или обновляет существующий в зависимости от наличия select
     */
    checkForm () {
      const finalizer = (val) => {
        this.$emit('save')
      }
      const catcher = (data, url) => {
        this.errors.fields = data
      }
      if (this.select) {
        this.updateUserPhone({
          data: this.form,
          id: this.select.id,
          finalizer,
          catcher,
        })
      } else {
        this.createUserPhone({
          data: this.form,
          finalizer,
          catcher,
        })
      }
    },
    /**
     * Генерирует событие close для закрытия диалогового окна
     */
    close () {
      this.$emit('close')
    },
  },
  /**
   * Инициализирует компонент: загружает данные и заполняет форму при редактировании
   */
  created () {
    if (!this.contactType) {
      this.loadSelectors()
    }
    if (this.accountCountryCode.length === 0) {
      this.loadChoices()
    }
    if (this.select) {
      this.form.code = this.select.country_id
      this.form.number = this.select.number
      this.form.kind = this.select.kind
      this.form.is_visible = this.select.is_visible
    }
  },
}
</script>

<style scoped></style>
